import { trackEvent } from './tracking';

export const REMINDER_SETUP_PROMPT_SKIPPED_SESSION_KEY = 'reminderSetupPromptSkippedThisSession';
export const REMINDER_SETUP_PROMPT_SNOOZED_AT_KEY = 'reminderSetupPromptSnoozedAt';
export const REMINDER_SETUP_EVENT_TRACKED_KEY = 'reminderSetupEventTracked';
export const REMINDER_SETUP_PROMPT_SNOOZE_MS = 7 * 24 * 60 * 60 * 1000;

export function hasReminderSetupPromptBeenSkippedThisSession() {
  return sessionStorage.getItem(REMINDER_SETUP_PROMPT_SKIPPED_SESSION_KEY) === 'true';
}

export function hasReminderSetupPromptBeenSnoozed({ now = Date.now() } = {}) {
  const snoozedAt = Number.parseInt(localStorage.getItem(REMINDER_SETUP_PROMPT_SNOOZED_AT_KEY), 10);
  return !Number.isNaN(snoozedAt) && now - snoozedAt < REMINDER_SETUP_PROMPT_SNOOZE_MS;
}

export function skipReminderSetupPromptForSession() {
  sessionStorage.setItem(REMINDER_SETUP_PROMPT_SKIPPED_SESSION_KEY, 'true');
}

export function snoozeReminderSetupPrompt({ now = Date.now() } = {}) {
  localStorage.setItem(REMINDER_SETUP_PROMPT_SNOOZED_AT_KEY, String(now));
}

export function shouldShowReminderSetupPrompt({
  hasPreferences,
  shouldPromptPlacementTest = false,
  skippedThisSession = hasReminderSetupPromptBeenSkippedThisSession(),
  now = Date.now(),
  snoozed = hasReminderSetupPromptBeenSnoozed({ now }),
} = {}) {
  return hasPreferences !== true
    && shouldPromptPlacementTest !== true
    && skippedThisSession !== true
    && snoozed !== true;
}

function parseStoredNotificationPreferences() {
  try {
    const stored = localStorage.getItem('notificationPreferences');
    return stored ? JSON.parse(stored) : null;
  } catch (error) {
    console.warn('Unable to parse stored notification preferences for analytics backfill', error);
    return null;
  }
}

function buildReminderSetupEventProperties(preferences, source, backfilled = false) {
  const calendarState = preferences?.channels?.calendar || {};
  return {
    source,
    backfilled,
    days: Array.isArray(preferences?.reminderDays)
      ? preferences.reminderDays.filter(Boolean).length
      : null,
    time: preferences?.reminderTime || null,
    email: preferences?.channels?.email ?? null,
    calendar_google: calendarState.addedGoogle === true,
    calendar_outlook: calendarState.addedOutlook === true,
    calendar_ics: calendarState.downloadedIcs === true,
  };
}

export function markReminderSetupEventTracked() {
  localStorage.setItem(REMINDER_SETUP_EVENT_TRACKED_KEY, 'true');
}

export function hasReminderSetupEventBeenTracked() {
  return localStorage.getItem(REMINDER_SETUP_EVENT_TRACKED_KEY) === 'true';
}

export function trackReminderSetupEvent(preferences, { source = 'unknown', backfilled = false } = {}) {
  trackEvent('madameai_reminder_setup', buildReminderSetupEventProperties(preferences, source, backfilled));
  markReminderSetupEventTracked();
}

export function backfillReminderSetupEventIfNeeded({
  hasPreferences,
  preferences = parseStoredNotificationPreferences(),
} = {}) {
  if (hasPreferences !== true || hasReminderSetupEventBeenTracked()) {
    return false;
  }

  trackReminderSetupEvent(preferences, { source: 'backfill', backfilled: true });
  return true;
}
